<template>
  <div class="register page">
    <loginComp title="Register Page"></loginComp>
  </div>
</template>
<script>
import LoginComp from "@/components/LoginComp.vue";
export default {
  components: {
    loginComp: LoginComp,
  },
};
</script>
